// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 474 ? "fe69a73d" : chunkId) + "." + {"474":"571b3a16e5311691","4917":"7e1428aa36694408","7992":"7897262d304312c2"}[chunkId] + ".js";
};